import {combineReducers} from 'redux'
import urlInfo from './urlInfoReducer'
import { stashUrlHistory } from './urlHistoryReducer'
import rootMarketplaceAppReducer from '../../apps/marketplace-app/state/rootMarketplaceAppReducer'
export default combineReducers({
  ...rootMarketplaceAppReducer,
  urlInfo,
  stashUrlHistory,
})
